import React, { useContext, useEffect, useState } from 'react'
import AllList from '../AllList'
import { fetchStatus } from '../../services/managerApi/statusApi'
import { DContext } from '../../../context/Datacontext'
import Status from './Status'

export default function StatusList() {

    const { BeURL, showAlert } = useContext(DContext)

    const [status, setStatus] = useState(null)
    const [statusView, setStatusView] = useState(false)
    const [statusId, setStatusId] = useState(null)
    const [createPopup, setCreatePopup] = useState(false)

    useEffect(() => {
        const fetchstatus = async () => {
            await fetchStatus(BeURL, showAlert, setStatus)
        }
        fetchstatus()
    }, [])
    return (
        <div className="min-h-[80vh] p-6">

            <h2 className="text-center text-2xl font-semibold text-primary-600 my-2">
                Status
            </h2>

            <div className=' flex justify-end my-2 px-16'>

                <button className='rounded-full px-4 py-1 text-md bg-secondary-500 hover:bg-secondary-600 text-white' onClick={() => setCreatePopup(true)}>Create Status</button>

            </div>

            <div
                className="gap-6"
                style={{ alignContent: 'center' }}
            >
                <AllList status={status} setStatusView={setStatusView} setStatusId={setStatusId}/>
            </div>

            {/* PopupUpdate */}
            <div>
                <Status statusView={statusView} setStatusView={setStatusView} statusId={statusId} />
                <Status statusView={createPopup} setStatusView={setCreatePopup} />
            </div>
        </div>
    )
}
